/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ColDef } from 'ag-grid-enterprise';
import {
  FIVE_DIGIT_WIDTH,
  TEXT_WIDTH,
  numberAsStringComparator,
  incompleteCellRenderer,
  deltaTargetCellRenderer,
  threeDecimalValueFormatter,
} from 'components/common/Tables/CommonGridFormatters';

export enum LapDeltaTableColId {
  Location = 'location',
  Target = 'target',
  Driver = 'driver',
  Delta = 'delta',
  Total = 'total',
}

const locationComparator = (valueA: string, valueB: string) => {
  if (valueA === 'SF') return 1;
  if (valueB === 'SF') return -1;
  const numA = parseInt(valueA?.replace(/\D/g, ''), 10);
  const numB = parseInt(valueB?.replace(/\D/g, ''), 10);
  return numA - numB;
};

const deltaCellStyle = (params: any) => {
  if (params.value < 0) {
    return { backgroundColor: 'green', color: 'white' };
  } else if (params.value > 0) {
    return { backgroundColor: 'red', color: 'white' };
  }
  return { backgroundColor: 'transparent', color: 'default' };
};

export const lapDeltaTableColDefs: ColDef[] = [
  {
    colId: LapDeltaTableColId.Location,
    field: 'loopName',
    headerName: 'Location',
    headerTooltip: 'Last Line Crossing',
    sort: 'asc',
    type: 'rightAligned',
    initialWidth: TEXT_WIDTH,
    suppressHeaderMenuButton: true,
    comparator: locationComparator,
    cellRenderer: incompleteCellRenderer,
  },
  {
    colId: LapDeltaTableColId.Target,
    headerName: 'Target',
    headerTooltip: 'Target Vehicle best lap',
    type: 'numericColumn',
    initialWidth: FIVE_DIGIT_WIDTH,
    suppressHeaderMenuButton: true,
    cellRenderer: deltaTargetCellRenderer,
    valueFormatter: threeDecimalValueFormatter,
  },
  {
    colId: LapDeltaTableColId.Driver,
    headerName: 'Ref Vehicle',
    headerTooltip: 'Reference Vehicle best lap',
    type: 'numericColumn',
    initialWidth: FIVE_DIGIT_WIDTH,
    suppressHeaderMenuButton: true,
    cellRenderer: incompleteCellRenderer,
    valueFormatter: threeDecimalValueFormatter,
  },
  {
    colId: LapDeltaTableColId.Delta,
    headerName: 'Delta',
    headerTooltip: 'Delta to target vehicle',
    type: 'rightAligned',
    comparator: numberAsStringComparator,
    initialWidth: FIVE_DIGIT_WIDTH,
    suppressHeaderMenuButton: true,
    cellRenderer: incompleteCellRenderer,
    valueFormatter: threeDecimalValueFormatter,
    cellStyle: deltaCellStyle,
  },
  {
    colId: LapDeltaTableColId.Total,
    headerName: 'Total',
    headerTooltip: 'Total delta time to target vehicle best lap',
    type: 'rightAligned',
    comparator: numberAsStringComparator,
    initialWidth: FIVE_DIGIT_WIDTH,
    suppressHeaderMenuButton: true,
    cellRenderer: incompleteCellRenderer,
    valueFormatter: threeDecimalValueFormatter,
    cellStyle: deltaCellStyle,
  },
];
